import axios from 'axios'

export const checkPin = ({
  pinCode: pin,
  cookies,
  setCookie,
  setQuizPreview,
  setStartTime,
  quizData,
  setQuizData,
  setErrors,
  fromPlay,
  router,
  setLoading
}) => {
  axios
    .get(`${process.env.base_engine}/quiz-info.php?pin=${pin}`)
    .then(function (response) {
      const { data } = response
      console.log('data:%o', data)
      setErrors(false)

      if (
        cookies.quiz_uuid === data.uuid &&
        cookies.public_user_uuid &&
        cookies.user_uuid &&
        cookies.user_name
      ) {
        if (response.is_single_play) {
          setCookie('quiz_uuid', data.uuid, { path: '/' })

          router.push('/play/quiz?pin=' + pin)
        } else {
          router.push('/quiz')
        }
        return
      } else {
        router.push('?pin=' + pin)
        setCookie('quiz_uuid', data.uuid, { path: '/' })
      }

      const now = Date.now()

      if (data.scheduled_at) {
        const parsedDate = parseInt(
          new Date(data.scheduled_at.replace(/-/g, '/')).getTime().toFixed(0)
        )
        if (
          data.scheduled_at &&
          now < parsedDate &&
          now + 600000 < parsedDate
        ) {
          if (parsedDate !== false) setStartTime(parsedDate)
          const timeCheck = setInterval(() => {
            const tenMins = Date.now() + 600000
            if (tenMins > parsedDate) {
              clearInterval(timeCheck)
              setStartTime(false)
            }
          }, 1000)
        }
      }

      const newQuizData = {
        id: data.id,
        uuid: data.uuid,
        title: data.name,
        host: data.host_name,
        image: data.image ?? false,
        scheduled_at: data.scheduled_at ?? false,
        started_at: data.started_at ?? false,
        desktop_image: data.desktop_image ?? false,
        mobile_image: data.mobile_image ?? false,
        logo: data.logo ?? false,
        solo_footer_logo: data.solo_footer_logo ?? false,
        is_kblive: data.is_kblive ?? false,
        league_id: data.league_id ?? false,
        league_colour: data.league_colour ?? '1',
        league_name: data.league_name ?? false,
        single_play_started_at: data.single_play_started_at ?? false,
        single_play_ended_at: data.single_play_ended_at ?? false,
        single_play_randomise_questions_count:
          data.single_play_randomise_questions_count ?? false,
        is_single_play: data.is_single_play ?? false,
        is_single_play_venue_dropdown:
          data.is_single_play_venue_dropdown === true ||
          data.is_single_play_venue_dropdown === '1' ||
          data.is_single_play_venue_dropdown === 1,
        guest_solo_play_limit: data.guest_solo_play_limit ?? false,
        guest_solo_play_time_limit: data.guest_solo_play_time_limit ?? '0',
        instant_win_threshold: data.instant_win_threshold ?? false,
        pub_list_url: data.pub_list_url ?? false,
        is_single_play_randomised: data.is_single_play_randomised ?? false,
        is_guest_play:
          data.is_guest_play === true ||
          data.is_guest_play === '1' ||
          data.is_guest_play === 1,
        description: data.description ?? false,
        users_outro_button_copy: data.users_outro_button_copy ?? false,
        users_outro_button_url: data.users_outro_button_url ?? false,
        outro_button_copy: data.outro_button_copy ?? false,
        outro_button_url: data.outro_button_url ?? false,
        is_custom_terms:
          data.is_custom_terms === true ||
          data.is_custom_terms === '1' ||
          data.is_custom_terms === 1,
        is_age_gate:
          data.is_age_gate === true ||
          data.is_age_gate === '1' ||
          data.is_age_gate === 1,
        is_confetti_hidden:
          data.is_confetti_hidden === true ||
          data.is_confetti_hidden === '1' ||
          data.is_confetti_hidden === 1,

        custom_terms_text: data.custom_terms_text ?? false,
        custom_terms_link: data.custom_terms_link ?? false,
        custom_terms_link_text: data.custom_terms_link_text ?? false,
        has_company_terms:
          data.has_company_terms === true ||
          data.has_company_terms === '1' ||
          data.has_company_terms === 1,
        company_id: data.company_id ?? false
      }
      setQuizPreview(newQuizData)
      setQuizData({
        ...quizData,
        ...newQuizData
      })

      setCookie('pin', data.pin, { path: '/' })
      if (setLoading) setLoading(false)
    })
    .catch(function (err) {
      if (err.response) {
        const { status } = err.response
        if (status === 404) {
          setQuizPreview(false)
          setErrors({ pin: ["Sorry, that isn't a valid KwizzPIN"] })
        }
      }
    })
}
